import { render, staticRenderFns } from "./BestPriceColumn.vue?vue&type=template&id=638f5390&"
import script from "./BestPriceColumn.vue?vue&type=script&lang=js&"
export * from "./BestPriceColumn.vue?vue&type=script&lang=js&"
import style0 from "./BestPriceColumn.vue?vue&type=style&index=0&id=638f5390&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports